module.exports = __webpack_public_path__ + "img/default-cover.215febc1.png";